import React from "react";

import { showDialogAsync } from "../../dialog-queue";
import { ConfirmDialog } from "../../dialog/confirm";
import { labels } from "./labels";

export const showLeaveDialogAsync = () =>
	showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
		<ConfirmDialog
			cancelLabel={labels.backToProduct}
			titleLabel={labels.title}
			messageHtmlLabel={labels.message}
			isOpen={isOpen}
			okLabel={labels.leave}
			onOk={() => resolve(true)}
			onCancel={() => resolve(false)}
		/>
	));
